import React, { useState } from 'react';
import {
  Shield,
  Heart,
  Phone,
  Mail,
  MapPin,
  Clock,
  Handshake,
  ChevronRight
} from 'lucide-react';
import './Nosotros.css';
import baseURL from '../url';
import Navbar from '../Navbar/Navbar';
import imagenNosotros from '../../images/img-web_nosotros.jpeg';

const Nosotros = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => formDataToSend.append(key, formData[key]));

      const response = await fetch(`${baseURL}/clientPost.php`, {
        method: 'POST',
        body: formDataToSend
      });
      const result = await response.json();

      if (response.ok && !result.error) {
        setSubmitMessage('MENSAJE ENVIADO CON ÉXITO.');
        setFormData({ nombre: '', apellido: '', email: '', telefono: '', mensaje: '' });
      } else {
        setSubmitMessage('ERROR AL ENVIAR.');
      }
    } catch (error) {
      setSubmitMessage('ERROR DE CONEXIÓN.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ido-nosotros-root">
      <Navbar />

      {/* HERO SECTION - ADN GRUPO ANTUN */}
      <section className="ido-nosotros-hero">
        <div className="binary-overlay">01010101</div>
        <div className="ido-container hero-grid">
          <div className="hero-text-box">
            <span className="ido-tag">NOSOTROS</span>
            <h1 className="hero-main-title">GRUPO <span className="text-red">ANTUN</span></h1>
            <h2 className="hero-sub-title">TRAYECTORIA Y EXCELENCIA</h2>
            <p className="hero-p">
              Con más de tres décadas en el mercado cordobés, <strong>Grupo Antun</strong> ha construido una sólida trayectoria a través de concesionarios líderes como
              Chexa (Chevrolet), Turin (Fiat), Hiper Auto (Hyundai), Hiper Platinum (Kia) y Jea (Jeep).
              <br /><br />
              Hoy reafirmamos nuestro compromiso con la innovación y la calidad sumando a nuestra propuesta las reconocidas marcas japonesas <strong>Subaru y Suzuki</strong>,
              ampliando nuestra oferta con tecnología, confiabilidad y prestigio internacional.
            </p>
            <div className="stats-grid">
              <div className="stat-card">
                <span className="stat-num">+30</span>
                <span className="stat-txt">AÑOS DE TRAYECTORIA</span>
              </div>
              <div className="stat-card">
                <span className="stat-num">99%</span>
                <span className="stat-txt">SATISFACCIÓN</span>
              </div>
            </div>
          </div>
          <div className="hero-img-box">
            <img src={imagenNosotros} alt="IDO Showroom" className="img-main" />
            <div className="img-border-accent"></div>
          </div>
        </div>
      </section>

      {/* VALORES - BLOQUE GRIS TÉCNICO */}
      <section className="ido-values">
        <div className="ido-container">
          <h2 className="section-h2">NUESTROS VALORES <span className="text-red">_</span></h2>
          <div className="values-flex">
            <div className="value-item">
              <Shield className="text-red" size={40} />
              <h3>TRANSPARENCIA</h3>
              <p>Sin letras chicas. Información técnica real de cada unidad desde el primer contacto.</p>
            </div>
            <div className="value-item">
              <Handshake className="text-red" size={40} />
              <h3>RESPALDO</h3>
              <p>La trayectoria de Grupo Antun garantiza una operación segura y profesional en cada etapa.</p>
            </div>
            <div className="value-item">
              <Heart className="text-red" size={40} />
              <h3>PRECISIÓN</h3>
              <p>Atención personalizada enfocada en encontrar el vehículo ideal para tu estilo de vida.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACTO - DATOS ACTUALIZADOS */}
      <section className="ido-contact">
        <div className="ido-container contact-split">
          <div className="contact-info-side">
            <h2 className="title-huge">CENTRO <span className="text-red">DE CONTACTO</span></h2>
            <p className="p-margin">Nuestro equipo de especialistas está listo para asesorarte en nuestras sucursales oficiales.</p>

            <div className="info-list">
              <div className="info-row">
                <MapPin className="text-red" />
                <div className="info-location-group">
                  <span>Av. Fuerza Aérea 3850, Córdoba Capital</span>
                  <span className="location-detail">Complejo Mercomax, Local 9 y 10, Río Cuarto</span>
                </div>
              </div>
              <div className="info-row">
                <Phone className="text-red" />
                <span>+54 9 351 347 7034</span>
              </div>
              <div className="info-row">
                <Mail className="text-red" />
                <span>idosuzukiysubaru@gmail.com</span>
              </div>
              <div className="info-row">
                <Clock className="text-red" />
                <span>Lunes a Viernes de 9 a 19 hs</span>
              </div>
            </div>
          </div>

          <form className="ido-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <input type="text" name="nombre" placeholder="NOMBRE" value={formData.nombre} onChange={handleInputChange} required />
              <input type="text" name="apellido" placeholder="APELLIDO" value={formData.apellido} onChange={handleInputChange} required />
              <input type="email" name="email" placeholder="EMAIL" value={formData.email} onChange={handleInputChange} required />
              <input type="tel" name="telefono" placeholder="TELÉFONO" value={formData.telefono} onChange={handleInputChange} />
            </div>
            <textarea name="mensaje" placeholder="CONSULTA TÉCNICA O COMERCIAL" rows="4" value={formData.mensaje} onChange={handleInputChange} required></textarea>

            <button type="submit" className="ido-btn-submit" disabled={isSubmitting}>
              {isSubmitting ? 'ENVIANDO...' : <>ENVIAR MENSAJE <ChevronRight size={18} /></>}
            </button>

            {submitMessage && <div className="ido-msg-status">{submitMessage}</div>}
          </form>
        </div>
      </section>
    </div>
  );
};

export default Nosotros;